import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Stream } from '../../shared/models';
import Chart from 'chart.js/auto';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
})
export class ChartComponent implements OnInit, OnDestroy {
  @Input() streams: Stream[];
  @Input() color;
  @Input() id = 'lineCanvas2';
  @Input() type;

  lineChart;
  datasets;
  lineWidth = 2;
  ticksX = false;
  ticksY = false;
  colors = {
    run: '#db7700',
    virtualrun: '#db7700',
    ride: '#16b800',
    virtualride: '#16b800',
    swim: '#2a7efc',
    walk: 'lime',
    hike: 'darkgreen',
    soccer: 'lime',
    runnergram: '#DE3163',
  };
  constructor() {}

  ngOnInit() {
    setTimeout(() => {
      this.generateChart();
    }, 200);
  }
  ngOnDestroy() {

  }

  generateChart() {
    const distanceData = this.streams?.find(
      (item) => item.type === 'distance'
    )?.data;
    const timeData = this.streams?.find((item) => item.type === 'time')?.data;
    const max = [...timeData].pop() as number;
    this.streams?.forEach((item) => {
      item.hidden = item.type !== 'heartrate';
      item.borderColor = 'red';
    });
    this.datasets = this.streams
      ?.filter(
        (stream) =>
          stream.type !== 'distance' &&
          stream.type !== 'time' &&
          stream.type !== 'latlng'
      )
      .map((item, index) => ({
        label: item.type,
        type: 'line',
        data: item.data.map((dataItem, i) => ({
          x: timeData[i],
          y: dataItem,
        })),
        hidden: item.hidden,
        borderColor: this.color ?? this.colors[this.type.toLowerCase()] ?? 'darkred',
        borderWidth: this.lineWidth,
        pointBorderWidth: 0,
        pointRadius: 0,
        spanGaps: true,
        borderJoinStyle: 'round',
        tension: 0.2,
        fill: false,
        yAxisID: 'y' + index,
      }));
    const yAxes = {};
    let visibleYAxesCount = 0;
    this.datasets.forEach((element, index) => {
      yAxes['y' + index] = {
        display: false,
        position: visibleYAxesCount % 2 === 0 ? 'left' : 'right',
        ticks: {
          count: 6,
        },
      };
      if (!element.hidden) {
        visibleYAxesCount++;
      }
    });
    const parent = this;
    this.lineChart = new Chart(
      document.getElementById(this.id) as HTMLCanvasElement,
      {
        type: 'scatter',
        data: {
          datasets: this.datasets,
        },
        options: {
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              type: 'linear',
              position: 'bottom',
              max,
              ticks: {
                maxRotation: 0, // Disable rotation
                minRotation: 0, // Disable rotation
                autoSkip: true, // Enable automatic skip
                stepSize: distanceData
                  ? max < 1000
                    ? 100
                    : 1000
                  : max < 600
                  ? 60
                  : 300,
                callback: (value) => {
                  if (value === max) {
                    return distanceData
                      ? max < 1000
                        ? value
                        : Math.round(((value + Number.EPSILON) / 1000) * 100) /
                          100
                      : parent.formatSeconds(value);
                  }
                  return distanceData
                    ? max < 1000
                      ? value
                      : Math.round(Number(value) / 1000)
                    : parent.formatSeconds(Number(value));
                },
                display: this.ticksX,
              },
              grid: {
                display: false,
                drawBorder: this.ticksX,
              },
            },
            ...yAxes,
          },
        },
      }
    );
  }

  formatSeconds(seconds: number): string {
    const minutes: number = Math.floor(seconds / 60);
    const remainingSeconds: number = seconds % 60;
    const formattedMinutes: string = String(minutes).padStart(2, '0');
    const formattedSeconds: string = String(remainingSeconds).padStart(2, '0');
    return `${formattedMinutes}:${formattedSeconds}`;
  }
}
